<script lang="ts">
import { defineComponent } from 'vue'

import AppNavigationItems from './AppNavigationItems.vue'

/**
 * AppNavigationButton
 */
export default defineComponent({
  components: {
    AppNavigationItems,
  },
  data() {
    return {
      open: true,
    }
  },
})
</script>

<template>
  <aside
    id="sidebarNav"
    ref="sidebarNav"
    class="sticky left-0 top-0 z-[2147483631] hidden h-svh w-fit overflow-y-auto border-r-10 border-r-slate-200 bg-pure-white pb-10 md:block"
    :class="{ open: open }"
  >
    <button
      type="button"
      class="m-3 flex w-fit items-center gap-2 whitespace-nowrap rounded-md bg-black px-3 py-2 text-sm leading-none text-pure-white"
      :class="{ 'mx-auto': !open }"
      :aria-expanded="open"
      @click="open = !open"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M20.8889 19.7778L21.0028 19.7832C21.563 19.8402 22 20.3137 22 20.8889C22 21.4641 21.563 21.9375 21.0028 21.9946L20.8889 22H3.11111C2.49746 22 2 21.5025 2 20.8889C2 20.2752 2.49746 19.7778 3.11111 19.7778H20.8889ZM20.8889 10.8889L21.0028 10.8943C21.563 10.9513 22 11.4248 22 12C22 12.5752 21.563 13.0487 21.0028 13.1057L20.8889 13.1111H3.11111C2.49746 13.1111 2 12.6137 2 12C2 11.3864 2.49746 10.8889 3.11111 10.8889H20.8889ZM20.8889 2L21.0028 2.00543C21.563 2.06246 22 2.53592 22 3.11111C22 3.68631 21.563 4.15976 21.0028 4.2168L20.8889 4.22222H3.11111C2.49746 4.22222 2 3.72476 2 3.11111C2 2.49746 2.49746 2 3.11111 2H20.8889Z"
          fill="currentColor"
        />
      </svg>

      <template v-if="open">Hide Menu </template>
    </button>

    <AppNavigationItems :open />
  </aside>
</template>

<style lang="scss" scoped></style>
